import { useMutation } from '@tanstack/react-query'
import { postExperiencePlan } from '../../service/payment'

export const usePostExperiencePlan = () => {
  return useMutation({
    mutationKey: ['experience-plan'],
    mutationFn: postExperiencePlan,
  })
}
